module.exports = __webpack_public_path__ + "static/media/state-awaiting.e2566d7a.svg";